var _a;
import { __decorate, __metadata } from "tslib";
import { Mutation, VuexModule, Module } from 'vuex-module-decorators';
import { Mutations } from '@/store/enums/finance/FinanceEnums';
let FinanceModule = class FinanceModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.listBreadcrumb = [];
    }
    get getFinanceListBreadcrumb() {
        return this.listBreadcrumb;
    }
    [_a = Mutations.SET_FINANCE_BREADCRUMB](payload) {
        this.listBreadcrumb = payload;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FinanceModule.prototype, _a, null);
FinanceModule = __decorate([
    Module
], FinanceModule);
export default FinanceModule;
